<template>	
	<div>
		<div v-if="$api.user.sysadmin" id="home-main"></div>
		<div v-else>
			<h1 class="view-title">
				<div class="filter-container">
					<div class="filter-container" data-v-step-home="1">
						<button class="chart-filter" :class="{ 'active': (search.filter == 'today') }" @click="filterResult('today')">
							HOJE
						</button>
						<button class="chart-filter" :class="{ 'active': (search.filter == 'week') }" @click="filterResult('week')">
							SEMANA
						</button>
						<button class="chart-filter" :class="{ 'active': (search.filter == 'interval') }" @click="filterResult('interval')">
							INTERVALO
						</button>
						<button class="btn btn-link btn-right" @click="$refs.tour.editTour()" data-v-step-home="2">
							<i class="fas fa-question-circle"></i> TOUR
						</button>
					</div>
				</div>
			</h1>
		
			<div class="inner-content">
				<div v-show="search.filter == 'interval'" class="row">
					<div class="col-xs-12">
						<div class="card shadowed">
							<div class="card-header" style="text-align: left;">
								<b>INFORME O INTERVALO</b>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-xs-12 col-lg-3">
										<FormInput v-model="search.dateStart" label="Início do intervalo" icon="fa-calendar-alt" type="date" :required="true" tooltip="Informe a data de início do período de filtragem" ref="dateStart" />
									</div>
									<div class="col-xs-12 col-lg-3">
										<FormInput v-model="search.dateEnd" label="Fim do intervalo" icon="fa-calendar-alt" type="date" :required="true" tooltip="Informe a data de término do período de filtragem" ref="dateEnd" />
									</div>
									<div class="col-xs-12 col-lg-2">
										<button class="button-edit button-search" @click="searchInterval()" style="width: 100%"><i class="fa fa-fw fa-search"></i> BUSCAR</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div class="row" style="padding-top: 30px;" data-v-step-home="3">
						<div v-for="(item, index) in dataDashboardCards" :key="index" class="col-xs-12 col-lg">
							<DashboardCard
							:icon="item.icon"
							:label="item.label"
							:color="item.color"
							:value="item.value"
							:loading="loading"
							ref="cards" />
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12 col-lg-5">
							<div class="card shadowed" data-v-step-home="4">
								<div class="card-header">
									<b>ENTREGAS POR STATUS <span v-popover:tooltip.right="'Gráfico do contador atual dos status'"><i class="fas fa-question-circle"></i></span></b>
								</div>
								<div class="card-body">
									<ChartDoughnut
									:currentData="dataChartDoughnut"
									:loading="loading"
									ref="chartDoughnut" />
								</div>
							</div>
						</div>
						<div class="col-xs-12 col-lg-5">
							<div class="card shadowed" data-v-step-home="5">
								<div class="card-header">
									<b>UTILIZAÇÃO DO APLICATIVO POR MOTORISTA <span v-popover:tooltip.right="'Gráfico referente a relação de utilização do APP DeliveryB2B pelos motoristas'"><i class="fas fa-question-circle"></i></span></b>
								</div>
								<div class="card-body">
									<ChartBar 
									:currentData="dataChartBar"
									:loading="loading"
									ref="chartBar" />
								</div>
							</div>
						</div>
						<div class="col-xs-12 col-lg-2">
							<div class="row" data-v-step-home="6">
								<div v-for="(item, index) in dataDashboardCards2" :key="index" class="col-xs-6 col-lg-12">
									<DashboardCard2
									:icon="item.icon"
									:label="item.label"
									:prefix="item.prefix"
									:value="item.value"
									:suffix="item.suffix"
									:loading="loading"
									ref="cards2" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<Tour
            tour="Home"
            :steps="tour_steps"
			:callbackOnFinish="true"
			ref="tour"
        />
	</div>
</template>

<script>
import Api from "@/lib/Api";

import ChartDoughnut from './Home/ChartDoughnut';
import ChartBar from './Home/ChartBar';
import DashboardCard from './Home/DashboardCard';
import DashboardCard2 from './Home/DashboardCard2';
import FormInput from "../components/FormInput.vue";
import Tour from "@/components/Tour";

export default {
	name: "Home",
	
	components: {
		ChartDoughnut,
		ChartBar,
		DashboardCard,
		DashboardCard2,
		FormInput,
		Tour,
	},

	data: function() {
		let searchStoraged = JSON.parse(window.localStorage.getItem('Dashboard.search'));

		if(!searchStoraged) {
			searchStoraged = {
				filter: "today",
				dateStart: "",
				dateEnd: "",
			}
		}

		return {
			loading: true,
			search: {
				filter: searchStoraged.filter,
				dateStart: searchStoraged.dateStart,
				dateEnd: searchStoraged.dateEnd,
			},
			dataDashboardCards: [
				{
					icon: "fa-boxes",
					label: "Total entrega",
					color: "#0a0a0a",
					value: 0
				},
				{
					icon: "fa-clock",
					label: "Aguardando",
					color: "#aaaaaa",					
					value: 0
				},
				{
					icon: "fa-play-circle",
					label: "A caminho",
					color: "#00b5ad",
					value: 0
				},
				{
					icon: "fa-check-circle",
					label: "Finalizado",
					color: "#00ff00",
					value: 0
				},
				{
					icon: "fa-exclamation-circle",
					label: "Não entregue",
					color: "#c70000",
					value: 0
				},
				{
					icon: "fa-minus-circle",
					label: "Desvinculada",
					color: "#646464",
					value: 0
				},
			],
			dataChartDoughnut: [0, 0, 0, 0, 0],
			dataChartBar: [0, 0, 0],
			dataDashboardCards2: [
				{
					icon: "fa-truck",
					label: "VEÍCULOS UTILIZADOS",
					value: 0,
				},
				{
					icon: "fa-weight-hanging",
					label: "PESO TRANSPORTADO",
					value: 0,
					suffix: "kg",
				},
				{
					icon: "fa-dollar-sign",
					label: "VALOR TOTAL NF",
					prefix: "R$",
					value: this.getMoney(0),
				},
			],
			
            tour_steps: [
                {
                    target: '[data-v-step-home="0"]',
                    header: {
                        title: '<code>INÍCIO</code>',
                    },
                    content: '<code>Clique no menu <b>INÍCIO</b> para ir a página incial do sistema, que conta com gráficos e informações gerais</code>',
                    params: {
                        placement: 'right',
                        highlight: false,
                    }
                },
				{
                    target: '[data-v-step-home="1"]',
                    header: {
                        title: '<code>FILTROS DE PERÍODO</code>',
                    },
                    content: '<code>Clique nos <b>FILTROS DE PERÍODO</b> para mudar a período de exibição das informações da página inicial</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
				{
                    target: '[data-v-step-home="2"]',
                    header: {
                        title: '<code>TOUR</code>',
                    },
                    content: '<code>Em caso de dúvida clique no botão <b>TOUR</b> para gerenciar a exibição do tour nessa seção, e assim ter um auxílio referente aos elementos da página</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-home="3"]',
                    header: {
                        title: '<code>CONTADORES DOS STATUS</code>',
                    },
                    content: '<code>Aqui serão exibidos os números das entregas por status no período determinado acima</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-home="4"]',
                    header: {
                        title: '<code>GRÁFICO DE STATUS</code>',
                    },
                    content: '<code>Aqui será exibido um gráfico referente aos status atuais no período determinado acima</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-home="5"]',
                    header: {
                        title: '<code>GRÁFICO DE UTILIZAÇÃO</code>',
                    },
                    content: '<code>Aqui será exibido um gráfico referente a relação de utilização do APP DeliveryB2B pelos motoristas no período determinado acima</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-home="6"]',
                    header: {
                        title: '<code>INFORMAÇÕES GERAIS</code>',
                    },
                    content: '<code>Aqui estarão exibidos as demais informações no período determinado acima</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ],
		}
	},

	mounted: function() {
		if(!this.$api.user.sysadmin) {
			this.$refs.tour.setTour();
			this.load();
		}
	},

	activated: function() {
		this.load();
	},

	methods: {
		// Retorna o valor formatado
		formatValue: function(value) {
			return typeof value != 'undefined' ? value.toLocaleString('pt-BR') : "0";
		},

		// Retorna o valor formatado
		getMoney: function(value) {
			if(value > 0) {
				let valueFormated = value.toLocaleString('pt-BR');
				if(valueFormated.includes(",")) {
					return valueFormated;
				} else {
					return valueFormated + ",00";
				}
			} else {
				return "0,00";
			}
		},
		
		// Atualiza o filtro
		filterResult: function(filter) {
			// Verifica se é o mesmo filtro
			if(filter != this.search.filter) {
				// Atualiza o filtro
				this.search.filter = filter;

				// Verifica qual o filtro e se deve já buscar
				if(filter != "interval") {
					// Armazena na cache do navegador
					window.localStorage.setItem('Dashboard.search', JSON.stringify(this.search));
					this.load();
				}
			}
		},
		
		// Busca o intervalo
		searchInterval: function() {
			window.localStorage.setItem('Dashboard.search', JSON.stringify(this.search));
			this.load();
		},
		
		// Reinicializa as informações do data
		cleanData: function() {
			this.dataDashboardCards = [
				{
					icon: "fa-boxes",
					label: "Total entrega",
					color: "#0a0a0a",
					value: 0
				},
				{
					icon: "fa-clock",
					label: "Aguardando",
					color: "#aaaaaa",					
					value: 0
				},
				{
					icon: "fa-play-circle",
					label: "A caminho",
					color: "#00b5ad",
					value: 0
				},
				{
					icon: "fa-check-circle",
					label: "Finalizado",
					color: "#00ff00",
					value: 0
				},
				{
					icon: "fa-exclamation-circle",
					label: "Não entregue",
					color: "#c70000",
					value: 0
				},
				{
					icon: "fa-minus-circle",
					label: "Desvinculada",
					color: "#646464",
					value: 0
				},
			];
			this.dataChartDoughnut = [0, 0, 0, 0, 0];
			this.dataChartBar = [0, 0, 0];
			this.dataDashboardCards2 = [
				{
					icon: "fa-truck",
					label: "VEÍCULOS UTILIZADOS",
					value: 0,
				},
				{
					icon: "fa-weight-hanging",
					label: "PESO TRANSPORTADO",
					value: 0,
					suffix: "kg",
				},
				{
					icon: "fa-dollar-sign",
					label: "VALOR TOTAL NF",
					prefix: "R$",
					value: this.getMoney(0),
				},
			];
		},

		// Retorna messagem de erro no campo determinado
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },

		// Verifica e valida inicialmente os campos
        validation: function() {
			// Inicia o objeto resultante
			let result = {
				filter: "",
				date: [],
			};
			
			// Inicia o verificador de error
			let error = false;
			
			// Adiciona o filtro
			result.filter = this.search.filter;

			// Verifica o filtro
			if(this.search.filter == "today") {
				let date = new Date();
				
				let year = date.getFullYear();
				let month = ((date.getMonth() + 1) < 10) ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
				let day = (date.getDate() < 10) ? "0" + date.getDate() : date.getDate();

				result.date.push(year + "-" + month + "-" + day);
			} // Verifica o filtro
			else if(this.search.filter == "week") {
				let dateStart = new Date();
				dateStart.setSeconds(dateStart.getSeconds() - 604800);
				
				let year = dateStart.getFullYear();
				let month = ((dateStart.getMonth() + 1) < 10) ? "0" + (dateStart.getMonth() + 1) : dateStart.getMonth() + 1;
				let day = (dateStart.getDate() < 10) ? "0" + dateStart.getDate() : dateStart.getDate();
				
				result.date.push(year + "-" + month + "-" + day);
				
				let dateEnd = new Date();

				year = dateEnd.getFullYear();
				month = ((dateEnd.getMonth() + 1) < 10) ? "0" + (dateEnd.getMonth() + 1) : dateEnd.getMonth() + 1;
				day = (dateEnd.getDate() < 10) ? "0" + dateEnd.getDate() : dateEnd.getDate();

				result.date.push(year + "-" + month + "-" + day);
			} // Verifica o filtro
			else if(this.search.filter == "interval") {
				// Data de início do intervalo
				if(this.search.dateStart == "") {
					this.$notification.error(this.message("DATA DE INÍCIO"));
					error = true;
				}
				
				// Data de fim do intervalo
				if(this.search.dateEnd == "") {
					this.$notification.error(this.message("DATA DE FIM"));
					error = true;
				}
				
				// Verifica se até agora teve erro
				if(!error) {
					let dateStart = this.search.dateStart.split("-");
					dateStart = new Date(dateStart[0], dateStart[1] - 1, dateStart[2], 23, 59, 59);

					let dateEnd = this.search.dateEnd.split("-");
					dateEnd = new Date(dateEnd[0], dateEnd[1] - 1, dateEnd[2], 23, 59, 59);
					
					// Verifica a data
					if(dateStart >= dateEnd) {
						this.$refs.dateStart.error = "Data inválida";
						this.$refs.dateEnd.error = "Data inválida";
						this.$notification.error("'DATA DE INÍCIO' não pode ser maior ou igual que a 'DATA DE FIM'.");
						error = true;
					} else {
						this.$refs.dateStart.error = "";
						this.$refs.dateEnd.error = "";
						
						let year = dateStart.getFullYear();
						let month = ((dateStart.getMonth() + 1) < 10) ? "0" + (dateStart.getMonth() + 1) : dateStart.getMonth() + 1;
						let day = (dateStart.getDate() < 10) ? "0" + dateStart.getDate() : dateStart.getDate();
						
						result.date.push(year + "-" + month + "-" + day);

						year = dateEnd.getFullYear();
						month = ((dateEnd.getMonth() + 1) < 10) ? "0" + (dateEnd.getMonth() + 1) : dateEnd.getMonth() + 1;
						day = (dateEnd.getDate() < 10) ? "0" + dateEnd.getDate() : dateEnd.getDate();

						result.date.push(year + "-" + month + "-" + day);
					}
				}
			}

			if(error) {
                return null;
            } else {
                return result;
            }
		},
		
		load: async function() {
			// Inicia o formulario
			let form = this.validation();
            
            // Verifica o formulário de validação
			if(form == null) {
				return;
            }
			
			// Inicia o objeto resultante
			let result = null;
			
			// Informa o carregamento
			this.loading = true;

			// Requisita
			try {
				result = await Api.post("home/dashboard", form);
			} catch(ex) {
				console.log(ex);
				
				// Informa o erro
				this.$notification.error("Não foi possível obter todas as informações.");

				// Informa o término do carregamento
				this.loading = false;

				return;
			}
			
			// Informa o término do carregamento
			this.loading = false;
			
			// Verifica se foi retornado algo
			if(result) {
				// Verifica se deu erro
				if (result.error) {
					// Verifica se há sessão
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						// Informa o erro
						this.$notification.error(result.data);
						return;
					}
				} else {
					// Limpa as informações
					this.cleanData();

					this.dataDashboardCards2[0].value = result.data.general.total_vehicle;
					this.dataDashboardCards2[1].value = this.formatValue(result.data.general.total_weight);
					this.dataDashboardCards2[2].value = this.getMoney(result.data.general.total_value);

					// Atualiza as informações dos cards e gráficos
					let totalDelivery = 0;
					result.data.delivery.map(item => {
						if(item.status == "waiting") {
							this.dataDashboardCards[1].value = item.total;
							this.dataChartDoughnut[0] = item.total;
						}
						if(item.status == "in_progress") {
							this.dataDashboardCards[2].value = item.total;
							this.dataChartDoughnut[1] = item.total;
						}
						if(item.status == "finished") {
							this.dataDashboardCards[3].value = item.total;
							this.dataChartDoughnut[2] = item.total;
						}
						if(item.status == "failed") {
							this.dataDashboardCards[4].value = item.total;
							this.dataChartDoughnut[3] = item.total;
						}
						if(item.status == "untracked") {
							this.dataDashboardCards[5].value = item.total;
							this.dataChartDoughnut[4] = item.total;
						}

						totalDelivery += item.total;
					});
					this.dataDashboardCards[0].value = totalDelivery;

					this.dataChartBar[0] = result.data.driver.total_driver;
					this.dataChartBar[1] = result.data.driver.total_not_used_app;
					this.dataChartBar[2] = result.data.driver.total_used_app;
				}
			} else {
				// Informa o erro
				this.$notification.error("Não foi possível obter todas as informações.");
				return;
			}
		},
	}
}
</script>

<style scoped>
#home-main {
	position: absolute;
	width: calc(100% - 285px);
	margin-left: -15px;
	height: 100%;
	background-image: url('../assets/background-min.jpg');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
}

.button-search {
	margin-top: 30px;
}
.chart-filter {
	border: none;
	border-left: none;
	background: #d9d9d9;
	color: #222;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 20px;
	margin-right: 10px;
}

.chart-filter.active {
	background: #a6a6a6;
}

.card {
	position: relative;
	display: block;
	height: auto;
	width: 100%;
	background-color: #fff;
	border-bottom: 1px solid #f0f0f0;
	border-radius: 4px;
	margin-bottom: 15px;
}

.card-header,
.card-body,
.card-footer {
	padding: 15px;
}

.card-header {
	/*border-top-left-radius: 4px;
	border-top-right-radius: 4px;*/
	border-bottom: 1px solid #ddd;
	background-color: #f0f0f0;
	text-align: center;
	font-size: 12px;
}

.card-body {
	border-radius: 4px;
}

.card-footer {
	/*border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;*/
	background-color: #f0f0f0;
	text-align: center;
	font-size: 12px;
}

.card-footer a {
	text-decoration: none;
	color: #2c3e50;
}
</style>